import { produce } from "immer";
import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import { bulkActionsActions } from "./actions.js";
import { BulkItemStatus } from "./types.js";
const getBulkActionsItemsReducer = () => {
  const itemsReducer = createReducer([]).handleAction(bulkActionsActions.setBulkActionsItems, (_, action) => action.payload).handleAction(bulkActionsActions.clearBulkActions, () => []);
  const actionsDataReducer = createReducer({}).handleAction(bulkActionsActions.setBulkActions, (state, action) => {
    return produce(state, (draftState) => {
      const updatedActionKeys = Object.keys(action.payload.state);
      if (!action.payload.shouldMergeState) {
        updatedActionKeys.forEach((actionKey) => {
          draftState[actionKey] = action.payload.state[actionKey];
        });
      } else {
        updatedActionKeys.forEach((actionKey) => {
          const newItems = action.payload.state[actionKey].map((item) => {
            const oldItem = draftState[actionKey]?.find((i) => i.itemId === item.itemId) ?? {
              value: {},
              status: BulkItemStatus.Skipped
            };
            const oldValue = oldItem.value;
            const newValue = item.value;
            return typeof newValue === "object" && typeof oldValue === "object" ? {
              ...item,
              value: { ...oldValue, ...newValue },
              status: item.status ?? oldItem.status
            } : { ...item, value: newValue, status: BulkItemStatus.Pending };
          });
          draftState[actionKey] = newItems;
        });
      }
    });
  }).handleAction(bulkActionsActions.changeBulkActionStatus, (state, action) => {
    return produce(state, (draftState) => {
      action.payload.items.forEach((payload) => {
        const updatedItem = draftState[action.payload.actionKey].find((i) => payload.itemId === i.itemId);
        updatedItem.status = payload.status;
      });
    });
  }).handleAction(bulkActionsActions.removeBulkActionsWithKey, (state, action) => {
    return produce(state, (draftState) => {
      draftState[action.payload] = [];
    });
  }).handleAction(bulkActionsActions.clearBulkActions, () => ({}));
  const validationResultsReducer = createReducer(null).handleAction(bulkActionsActions.setValidationResults, (_, action) => {
    return action.payload;
  }).handleAction(bulkActionsActions.clearBulkActions, () => null);
  const bulkOperationsReducer = createReducer({}).handleAction(bulkActionsActions.saveOperationId, (state, action) => {
    return produce(state, (draftState) => {
      draftState[action.payload.actionKey] = { id: action.payload.id, errorCode: action.payload.errorCode };
    });
  }).handleAction([bulkActionsActions.cleanOperationIds, bulkActionsActions.clearBulkActions], () => ({}));
  return {
    selectedItems: itemsReducer,
    actionsData: actionsDataReducer,
    validationResults: validationResultsReducer,
    bulkOperations: bulkOperationsReducer
  };
};
const stateReducer = combineReducers({
  ...getBulkActionsItemsReducer()
});
const bulkActionsReducer = combineReducers({
  state: stateReducer
});
export {
  bulkActionsReducer
};
//# sourceMappingURL=reducers.js.map
